// These must be the first lines.
import { Provider } from 'react-redux';

import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';

import './i18n';
import { store } from './redux/store';

const rootElement = document.getElementById('root');

window.addEventListener('pageshow', event => {
  if (event.persisted) {
    window.location.reload();
  }
});

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <Provider store={store}>
      <App />
    </Provider>
  );
}
